import React from "react";

import AuthState from "@sentrei/common/models/AuthState";

const AuthContext = React.createContext<AuthState>({
  profile: null,
  user: undefined,
  setProfile: () => {},
  setUser: () => {},
});

export default AuthContext;
